import axios from 'axios';

export const clientBrandApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/client-brand`,
    headers: {
        'Content-Type': 'application/json'
    }
})